import { experienceApiClient } from '@/config/httpClients';
import { LoginResponseSchema, type LoginResponse } from '../auth.schemas';
import type { VerifyAccountMethod } from '@/stores/store/auth-slice';
import { useGlobalStore } from '@/stores/store';

const confirmOTP = async ({
  channel,
  otpCode,
}: {
  channel: VerifyAccountMethod;
  otpCode: string;
}) => {
  const {
    authStore: { initialAccessToken: accessToken },
  } = useGlobalStore.getState();
  const response = await experienceApiClient
    .post<LoginResponse>('v1/oauth/token', {
      json: {
        channel,
        otp: otpCode,
        token: accessToken,
        token_type: 'customer_authentication_token',
        scope: 'access-superhub',
      },
    })
    .json();

  const safeParseResponse = LoginResponseSchema.safeParse(response);
  if (!safeParseResponse.success) {
    //TODO: Log error to Sentry
    console.error('Error validating confirmOTP', safeParseResponse.error);
    //Lie to TS in case of any runtime validation errors
    return response as LoginResponse;
  } else {
    return response;
  }
};

export { confirmOTP };
